import React from 'react';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const PullQuote = () => (
  <blockquote className="border-l-2 border-[#3d2a5c] pl-6 mb-10">
    <p className="text-lg sm:text-xl text-[#E8E4DF] italic leading-relaxed">
      I traded 20 years of corporate sales for a fascination with AI, a return to my art degree, and the kind of creative work that finally felt like mine.
    </p>
  </blockquote>
);

const StoryBody = () => (
  <div className="space-y-6 text-[#E8E4DF]">
    <p>I spent two decades in corporate tech sales, which taught me a lot — but it was never the thing I was meant to build my life around.</p>
    <p>Then AI entered the picture, and everything shifted. It opened a door back to the creative side of me that had been waiting patiently for years: the one shaped by art school, visual instinct, and a deep love of storytelling.</p>
    <p className="text-[#F0EDE8]">Now I create cinematic visuals for fantasy authors who want their worlds to feel vivid, immersive, and impossible to ignore. The goal is simple: make something so compelling people stop and want to know more.</p>
  </div>
);

const About = () => (
  <section id="our-story" className="py-24 lg:py-36 bg-[#0A0A0B]" data-testid="our-story-section">
    <div className="container mx-auto px-6">
      <div className="max-w-2xl mx-auto">
        <p className="label-sm text-[#14B8A6] mb-8" data-font="label">Our Story</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#F0EDE8] mb-10 leading-tight" data-testid="our-story-heading">
          The story behind Whisky Woven
        </h2>
        <PullQuote />
        <StoryBody />
        <div className="mt-10" data-font="label">
          <button onClick={() => scrollToSection('contact')} className="bg-[#14B8A6] hover:bg-[#0D9488] text-[#0A0A0B] font-medium px-8 py-3.5 text-sm uppercase tracking-[0.12em] transition-all duration-300 hover:shadow-lg hover:shadow-[#14B8A6]/20" data-testid="about-cta-btn">
            Bring Your World to Life
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default About;
